import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { FormProvider, useForm, useWatch } from 'react-hook-form'

//UI
import { Input } from '@/components/Form'
import { Box, Button, Flex, Text } from '@chakra-ui/react'
import ReCAPTCHA from 'react-google-recaptcha'

import { toast } from 'react-toastify'

import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
//Constant

import config, { APP_MODE } from '@/config'

import useAuth from '@/features/auth/useAuth'
import useVendor from '@/features/vendors/useVendor'
import { useTranslation } from 'react-i18next'

const VendorDetailForm = ({ requestorEmail }) => {
  const { useRegisterTempVendor } = useVendor()
  const { useVerifyRecaptcha } = useAuth()

  const methods = useForm()
  const recaptcha = useRef()

  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const registerTempVendor = useRegisterTempVendor()
  const verifyReCaptacha = useVerifyRecaptcha()

  const id = useWatch({ name: '_id', control: methods.control })

  const isProduction = config.mode == APP_MODE.PRODUCTION

  //Translated Data

  //Handler

  const onSubmit = async (data) => {
    try {
      dispatch(showLoadingOverlay())

      const captchaValue = recaptcha.current.getValue()

      if (!captchaValue) {
        toast.error('Please verify the reCAPTCHA!')
        return
      }

      try {
        const res = await verifyReCaptacha.mutateAsync({ captchaValue: captchaValue })

        if (!res?.success) {
          throw new Error('')
        }
      } catch (err) {
        toast.error('reCAPTCHA Validation failed ! ')
        return
      }

      recaptcha.current.reset()

      try {
        await registerTempVendor.mutateAsync({ ...data, requestorEmail: requestorEmail })
        toast.info('Successfully created an account in Siemens E-Approval-system')
        navigate(isProduction ? '/auth/login' : '/external/auth/login')
      } catch (err) {
        console.log(err)
        return
        // toast.error('Error in register temp vendor')
      }
      methods.reset({})
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Flex direction="column" gap={2} p="5">
          <Input name="name" label={t('REGISTER_PAGE_COMPANY_NAME')} type="text" placeholder="Enter value" isRow />

          <Input name="address" label={t('REGISTER_PAGE_ADDRESS')} placeholder="Enter value" isRow isRequired />

          <Input name="BRNumber" label={t('REGISTER_PAGE_BR_NUMBER')} placeholder="00000000" isRow isRequired />

          <Text as="b"> {t('REGISTER_PAGE_CONTACT_PERSON')} </Text>
          <Input name="contactPersonName" label={t('REGISTER_PAGE_CONTACT_NAME')} placeholder="Enter value" isRow />
          <Input name="contactPersonEmail" label={t('REGISTER_PAGE_CONTACT_EMAIL')} placeholder="Enter value" isRow />
          <Input
            name="contactPersonPhoneNumber"
            label={t('REGISTER_PAGE_CONTACT_PHONE_NUMBER')}
            placeholder="Enter value"
            isRow
          />
          <ReCAPTCHA ref={recaptcha} sitekey={config.siteKey} />

          <Box>
            <Button colorScheme="green" type="submit">
              {t('REGISTER_PAGE_SUBMIT')}
            </Button>
          </Box>
        </Flex>
      </form>
    </FormProvider>
  )
}

export default VendorDetailForm
